"use client";

import { c as _c } from "react/compiler-runtime";
import { SideSheetBody } from "@opensea/ui-kit";
import { isAddressEqual } from "@opensea/utils";
import { Suspense } from "react";
import { UnreachableCaseError } from "../../../lib/errors";
import { useAccount } from "../../../polychain/hooks";
import { ViewWalletHeader } from "./header/ViewWalletHeader";
import { ViewWalletTabMenu } from "./header/ViewWalletTabMenu";
import { CryptoTab, CryptoTabSkeleton } from "./tabs/CryptoTab/CryptoTab";
import { NftTab, NftTabSkeleton } from "./tabs/NftTab/NftTab";
export const ViewWalletFlowContent = t0 => {
  const $ = _c(13);
  const {
    address,
    tab,
    switchTab
  } = t0;
  let t1;
  if ($[0] !== address) {
    t1 = <ViewWalletHeader address={address} />;
    $[0] = address;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== address || $[3] !== switchTab || $[4] !== tab) {
    t2 = <ViewWalletTabMenu activeTab={tab} address={address} switchTab={switchTab} />;
    $[2] = address;
    $[3] = switchTab;
    $[4] = tab;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== address || $[7] !== tab) {
    t3 = <SideSheetBody className="flex flex-col gap-4 px-0 pt-6 lg:px-0"><TabContentSwitch address={address} tab={tab} /></SideSheetBody>;
    $[6] = address;
    $[7] = tab;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
const TabContentSwitch = t0 => {
  const $ = _c(14);
  const {
    address,
    tab
  } = t0;
  const {
    address: connectedAddress
  } = useAccount();
  let t1;
  if ($[0] !== address || $[1] !== connectedAddress) {
    t1 = isAddressEqual(connectedAddress, address);
    $[0] = address;
    $[1] = connectedAddress;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isProfileOwner = t1;
  switch (tab) {
    case "crypto":
      {
        let t2;
        if ($[3] !== isProfileOwner) {
          t2 = <CryptoTabSkeleton isProfileOwner={isProfileOwner} />;
          $[3] = isProfileOwner;
          $[4] = t2;
        } else {
          t2 = $[4];
        }
        let t3;
        if ($[5] !== address || $[6] !== isProfileOwner) {
          t3 = <CryptoTab address={address} isProfileOwner={isProfileOwner} />;
          $[5] = address;
          $[6] = isProfileOwner;
          $[7] = t3;
        } else {
          t3 = $[7];
        }
        let t4;
        if ($[8] !== t2 || $[9] !== t3) {
          t4 = <Suspense fallback={t2}>{t3}</Suspense>;
          $[8] = t2;
          $[9] = t3;
          $[10] = t4;
        } else {
          t4 = $[10];
        }
        return t4;
      }
    case "nfts":
      {
        let t2;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <NftTabSkeleton />;
          $[11] = t2;
        } else {
          t2 = $[11];
        }
        let t3;
        if ($[12] !== address) {
          t3 = <Suspense fallback={t2}><NftTab address={address} /></Suspense>;
          $[12] = address;
          $[13] = t3;
        } else {
          t3 = $[13];
        }
        return t3;
      }
    default:
      {
        throw new UnreachableCaseError(tab);
      }
  }
};